// extracted by mini-css-extract-plugin
export default {"wrapper":"HelpCenter_wrapper__jZXmD","cardsWrapper":"HelpCenter_cardsWrapper__NowAX"};